import React, { useState, useEffect, lazy } from 'react';
import { withRouter, Switch, Route } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import { AuthContext } from '../context/auth';
import { MobileDeviceContext } from '../context/util';
import { MakeRouteWithSubRoutes } from './makeSubRoutes';
import { routes } from './routes';
import Utils from 'utils/utils';
import { QueryParamProvider } from 'use-query-params';
import LoadingOverlay from 'react-loading-overlay';
import styled from 'styled-components';
import MobileLayout from 'components/UI/AtomicDesign/Organism/MobileLayout';
import DesktopLayout from 'components/UI/AtomicDesign/Organism/DesktopLayout';
import './global-styles.scss';
import withClearCache from 'components/HOC/ClearCache/ClearCache';
const Toaster = lazy(() => import('components/Toaster'));

const theme = createTheme({
  typography: {
    fontFamily: "'Baloo 2', sans-serif",
  },
  palette: {
    primary: {
      light: '#616161',
      main: '#3A3A3A',
      dark: '#282828',
      contrastText: '#FFFFFF',
    },
    secondary: {
      light: '#528BF3',
      main: '#276EF1',
      dark: '#1B4DA8',
      contrastText: '#FFFFFF',
    },
    action: {
      light: '#FFFFFF',
      main: '#FFFFFF',
      dark: '#B2B2B2',
      contrastText: '#000000',
    },
  },
});

const StyledLoader = styled(LoadingOverlay)`
  ._loading_overlay_overlay {
    position: fixed;
    z-index: 10000000000;
  }
`;
const Routes = ({ location }) => {
  const existingAuth = localStorage.getItem('userInfo') ? true : false;
  const [isAuthenticated, setIsAuthenticated] = useState(existingAuth);
  const [isMobile, setDevice] = useState(false);
  const [showAppBar, setShow] = React.useState(false);

  const loader = useSelector((state) => state.app.loader);

  useEffect(() => {
    if (Utils.detectMob()) {
      setDevice(true);
    }
  }, []);

  React.useEffect(() => {
    if (
      !location.search.includes('token') &&
      !location.pathname.includes('/operations/details') &&
      !location.pathname.includes('/placement/details') &&
      !location.pathname.includes('/portal/login') &&
      !location.pathname.includes('/ticketing/details')
    ) {
      setShow(true);
    } else {
      setShow(false);
    }
  }, [location.search, location.pathname]);

  const setAuthentication = () => {
    localStorage.setItem('isAuthenticated', true);
    setIsAuthenticated(true);
  };
  return (
    <ThemeProvider theme={theme}>
      <StyledLoader active={loader} spinner text="Processing" />
      <QueryParamProvider ReactRouterRoute={Route}>
        <AuthContext.Provider value={{ isAuthenticated, setIsAuthenticated: setAuthentication }}>
          <MobileDeviceContext.Provider value={{ isMobile }}>
            {isMobile ? (
              <MobileLayout isAuthenticated={isAuthenticated} showAppbar={showAppBar}>
                <Switch>
                  <Redirect exact from="/" to="/portal/operator" />
                  {routes.map((route, index) => (
                    <MakeRouteWithSubRoutes key={index} {...route} />
                  ))}
                </Switch>
              </MobileLayout>
            ) : (
              <div style={{ textAlign: 'center' }}>
                <DesktopLayout isAuthenticated={isAuthenticated} showAppbar={showAppBar}>
                  <Switch>
                    <Redirect exact from="/" to="/portal/operator" />
                    {routes.map((route, index) => (
                      <MakeRouteWithSubRoutes key={index} {...route} />
                    ))}
                  </Switch>
                </DesktopLayout>
              </div>
            )}
          </MobileDeviceContext.Provider>
        </AuthContext.Provider>
      </QueryParamProvider>
      <Toaster />
    </ThemeProvider>
  );
};
export default withClearCache(withRouter(Routes));
